<template>
    <Navbar :title="'服务评价'" :leftArrow="leftArrow"></Navbar>
    <div class="policy-file-item-footer">
      <div>{{form.create_time}}</div>
      <div v-if="form.salesman && form.salesman.name "> 服务人员：<span>{{form.salesman.name}}</span></div>
    </div>
    <div class="policy-detail">
        <div class="card" v-for="item in items" :key="item.title">
            <div class="card-title">
                <div class="flex-title-text">
                    {{ item.title }}
                </div>
            </div>
            <div class="card-content" v-if="item.type == 'text'">
                {{ form.service_content || '' }}
            </div>
            <div class="card-content" v-if="item.type == 'radio'">
                <van-radio-group v-model="form.service_evaluation" v-if="item.type == 'radio'">
                    <van-radio v-for="k in radioList" :key="k.value" :name="k.value" :disabled="queryType == 'look'">
                        {{ k.name }}</van-radio>
                </van-radio-group>
            </div>
            <div class="card-content" v-if="item.type == 'textarea'">
                <van-field v-model="form.evaluation_remark" rows="5" autosize type="textarea" maxlength="300"
                    placeholder="请输入评价备注" show-word-limit :readonly="queryType == 'look'" />
            </div>
        </div>
    </div>

    <div class="float-action" v-if="queryType != 'look'">
        <div class="flex-item" @click="submit">
            <van-button class="btn" type="primary">
                提交评价
            </van-button>
        </div>
    </div>
</template>
<script>
import { useRouter, useRoute } from "vue-router"
import Navbar from '@/components/Navbar.vue'
import ListItem from '@/components/ListItem.vue'
import {getEvaluationDetail,addEvaluation,updateEvaluation,getSNUser} from '@/api/home'
import store from '@/store'

export default {
    name: 'MattersEvaluateDetail',
    data() {

        return {
            active: '1',
            form: {
                id:'',
                userId: '',
                evaluation_remark: '',
                service_evaluation: 5,
                service_content: '线下拜访评价'
            },
            detail: {},
            queryType: '',

            items: [
                { title: '服务内容', type: 'text' },
                { title: '服务评价', type: 'radio' },
                { title: '评价备注', type: 'textarea' },
            ],
            radioList: [
                { name: '5分：很满意', value: 5 },
                { name: '4分：基本满意', value: 4 },
                { name: '3分：中规中矩', value: 3 },
                { name: '2分：不满意', value: 2 },
                { name: '1分：非常不满意', value: 1 }
            ],
            leftArrow: true
        }
    },
    components: { Navbar, ListItem },
    computed: {},
    watch: {},
    mounted() {
        this.init()
    },

    methods: {
        init() {
            this.queryType = this.$route.query.type || 'edit'
            this.form.id = this.$route.query.id
            if(this.queryType == 'add'){
                this.form.sn = this.$route.query.sn
                this.leftArrow = false
            

                if(this.$route.query.matterType == '1'){
                    this.form.service_content = '线下拜访评价'
                }
                // this.getSNUserByquery()
                this.addEvaluation()
            }else{
                this.leftArrow = true
                this.getData()
            }
            if (this.$route.query.type != 'look') {
                this.form.service_evaluation = 5
                this.form.evaluation_remark = ''
            }
        },
        async getSNUserByquery(){
            let res = await getSNUser({sn: this.$route.query.sn})
            this.form.salesmanId = res.data.id
            this.addEvaluation()
        },
        async getData() {
            try{
               let res = await getEvaluationDetail({id:this.form.id})
               this.form = res.result
            } catch {}
        },
        async submit() {
            let { service_evaluation, evaluation_remark,id,sn } = this.form
            if(!service_evaluation){
                this.$toast({message:'请至少选择一项服务评价',duration:2000})
                return false
            }
            let params = {
                type: 1,
                service_evaluation: service_evaluation,
                evaluation_remark: evaluation_remark,
                id: id,
                sn: sn
            }
            let res = await updateEvaluation(params)
            this.$toast.success('提交成功')
            if(this.queryType != 'add'){
                setTimeout(()=>{
                    this.$router.go(-1)
                },2000)
            }else{
                this.queryType = 'look'
            }
        },
        async addEvaluation(){
             let { sn,service_content } = this.form
            let params = {
                type: 1,
                sn: sn,
                service_content: service_content
            }
            try{
                let res = await addEvaluation(params)
                this.form = Object.assign({},this.form,{
                    ...res.result,
                    service_evaluation: 5,
                    evaluation_remark: ''
                }) || {}
                console.log(this.form)
            } catch{

            }
        }

    },
}

</script>
<style lang="scss">
</style>